import { Component, Input } from "@angular/core";

@Component({
    selector: "app-fixed-scroll-pagination",
    templateUrl: "./fixed-scroll-pagination.component.html",
    styleUrls: ["./fixed-scroll-pagination.component.scss"]
})
export class FixedScrollPaginationComponent {

    @Input() page: number;
    @Input() pages: string[];

    constructor() { }
}
